import { loc, mapBackEndDateToMomentObject } from "../../../core/utils"
import moment from "moment-timezone"

const statusList = {
  TOUS: 0,
  ACCEPTED_AWAITING_FUNDING: 11,
  A_TRAITER_OCTROI: 18,
  PJ_UPLOADES: 19,
  WAITING_DOCUMENTS: 2,
  NOT_FINALIZED: 1,
  REFUSED_AFTER_DOCUMENT_ANALYSIS: 25,
  REJECTED: 3
}
export const filterStatusOptionList = {
  TOUS: 0,
  ACCEPTED_AWAITING_FUNDING: 11,
  A_TRAITER_OCTROI: 18,
  WAITING_DOCUMENTS: 2,
  NOT_FINALIZED: 1,
  REFUSED_AFTER_DOCUMENT_ANALYSIS: 25,
  REJECTED: 3
}

function useOrderListing() {
  const statusOPL = Object.keys(filterStatusOptionList).map((key) => {
    return {
      label: loc(key),
      value: key
    }
  })

  const sortsFilter = [
    { label: loc("newest"), value: "desc" },
    { label: loc("oldest"), value: "asc" }
  ]

  // Dates from the backend comes like this = [2023, 3, 16, 9, 42, 16, 446000000]
  function formatDate(date) {
    if (!date) return null
    const strDate = mapBackEndDateToMomentObject(date)
    return moment(strDate).tz(moment.tz.guess()).format("DD/MM/YYYY HH:mm")
  }

  function formatStatus(status) {
    const keys = Object.keys(statusList)
    const findElement = keys.find((key) => statusList[key] === Number(status))
    return findElement
  }

  return {
    statusOPL,
    sortsFilter,
    formatDate,
    formatStatus
  }
}

export default useOrderListing
